import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type CardVariant = '1' | '2' | '3';
export type CardHeadingLevel = 'h2' | 'h3';

@Component({
  selector: 'lib-card',
  imports: [TranslateModule],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  readonly title = input('');
  readonly content = input('');
  readonly variant = input<CardVariant>('1');
  /** Heading level of the card title; pick the one matching the page outline. */
  readonly headingLevel = input<CardHeadingLevel>('h3');
}
